import container, { containerVariants, ContainerVariantsType } from './container';
import heading, { headingVariants, HeadingVariantsType } from './heading';
import { CSSStandardProperties } from '../../../types/theme';

const featureGrid = {
  container,
  heading
};

export const featureGridVariants = {
  container: containerVariants,
  heading: headingVariants
};

export type FeatureGridVariantsType = 'container' | 'heading';

type CombinedFeatureGridVariantsType = ContainerVariantsType & HeadingVariantsType;

export interface FeatureGridType {
  /** The FeatureGrid subcomponent types. */
  Components: Record<FeatureGridVariantsType, Record<CombinedFeatureGridVariantsType, CSSStandardProperties>>;
  /** The FeatureGrid container Component. */
  Container: ContainerVariantsType;
  /** The FeatureGrid (Heading & Subheading) container styles. */
  Heading: HeadingVariantsType | HeadingVariantsType[];
}

export default featureGrid;
